module.exports = __webpack_public_path__ + "img/icon-bonus.e219d72.png";